import { Injectable } from '@angular/core';
import { Http, Headers, ResponseContentType } from '@angular/http';
import { Router } from '@angular/router'
import { Token } from '../manager/token';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators'
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CiinraAuditReportService {

  TokenCls
  constructor(private http: HttpClient, private router: Router) {
    this.TokenCls = new Token(this.router);

  }
  GetAllSupervisors(id): any {
    return this.http.get(environment.ApiUrl + '/api/citra-report-supervisor/client/' + id);
  }

  GetReportDownloadforDate(Clientid,currentWeek,fromDate,toDate,only_worked): any {
     return this.http.get(environment.ApiUrl + '/api/Get_CiiNRA_Audit_Report/' + Clientid + '/?Current_Week=' + currentWeek + '&From_Date=' + fromDate  + '&To_Date=' + toDate  + '&Only_Worked=' + only_worked , { responseType: 'blob'})
     .pipe(map(res => {
      return {
        filename: 'CiinraAuditReport.xlsx',
        data: res
      };
    }))
  }


  GetReportDownload(Clientid,currentWeek,only_worked): any {
    return this.http.get(environment.ApiUrl + '/api/Get_CiiNRA_Audit_Report/' + Clientid + '/?Current_Week=' + currentWeek +  '&Only_Worked=' + only_worked , { responseType: 'blob'} )
     .pipe(map(res => {
       return {
         filename: 'CiinraAuditReport.xlsx',
         data: res
       };
     }))
 }
  ReportDownloadConfig(Clientid):any {
    return this.http.get(environment.ApiUrl + '/api/report-download-config/' + Clientid);
  }
}
